import { trace } from 'rytm-helpers'
import Sound from './Sound'

let sounds = []

export const getSound = (params) => {
  let result = null
  // trace("get sound", params.path, "from sounds", sounds)
  sounds.forEach((sndIt) => {
    if (sndIt.path == params.path) {
      result = sndIt
    }
  })
  if (!result) {
    result = new Sound(params.path, params)
    sounds.push(result)
  }
  return result
}